import React from 'react';
import PropTypes from 'prop-types';
import { Level, Button, Card, Input } from '@selfdetermine/react-elements';
import { Form } from '@selfdetermine/react-forms';
import { useMutation, useDebounce, useLazyQuery } from '@selfdetermine/react-hooks';
import { gql } from '@selfdetermine/graphql';
import { PersonCard } from '@selfdetermine/react-matters';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  mutation($person: UpdatePersonInput) {\n    updatePerson(person: $person) {\n      firstName\n      lastName\n      bornAt\n      sex\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation createPerson($person: PersonInput) {\n    createPerson(person: $person) {\n      name\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query Person($person: ID!) {\n    viewer {\n      person(id: $person) {\n        id\n        firstName\n        lastName\n        bornAt\n        sex\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query ListPeople($page: Int!, $limit: Int!) {\n    viewer {\n      listPeople(page: $page, limit: $limit) {\n        totalCount\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n        edges {\n          node {\n            id\n            memberStatus\n            firstName\n            middleName\n            lastName\n            suffix\n            membershipNumber\n            bornAt\n            sex\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var PEOPLE_VIEWER = gql(_templateObject());
var GET_PERSON = gql(_templateObject2());
var ADD_PERSON_MUTATION = gql(_templateObject3());
var UPDATE_PERSON_MUTATION = gql(_templateObject4());

var useAddPerson = function useAddPerson() {
  var _useMutation = useMutation(ADD_PERSON_MUTATION),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      mutate = _useMutation2[0],
      meta = _useMutation2[1];

  var addPerson = function addPerson(person) {
    return mutate({
      variables: {
        person: person
      },
      refetchQueries: [{
        query: PEOPLE_VIEWER
      }]
    });
  };

  return [addPerson, meta];
};
var useUpdatePerson = function useUpdatePerson() {
  var _useMutation3 = useMutation(UPDATE_PERSON_MUTATION),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      mutate = _useMutation4[0],
      meta = _useMutation4[1];

  var updatePerson = function updatePerson(person) {
    return mutate({
      variables: {
        person: person
      },
      refetchQueries: [{
        query: GET_PERSON,
        variables: {
          person: person.id
        }
      }]
    });
  };

  return [updatePerson, meta];
};
var PersonForm = function PersonForm(_ref) {
  var onDone = _ref.onDone,
      onError = _ref.onError,
      onCancel = _ref.onCancel,
      defaultValues = _ref.defaultValues;

  var _useAddPerson = useAddPerson(),
      _useAddPerson2 = _slicedToArray(_useAddPerson, 2),
      addPerson = _useAddPerson2[0],
      addPersonMeta = _useAddPerson2[1];

  var _useUpdatePerson = useUpdatePerson(),
      _useUpdatePerson2 = _slicedToArray(_useUpdatePerson, 2),
      updatePerson = _useUpdatePerson2[0],
      updatePersonMeta = _useUpdatePerson2[1];

  var isCreate = !(defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id);
  return /*#__PURE__*/React.createElement(Form, {
    loading: isCreate ? addPersonMeta.loading : updatePersonMeta.loading,
    error: isCreate ? addPersonMeta.error : updatePersonMeta.error,
    defaultValues: defaultValues,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(form) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!isCreate) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return addPerson(form);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.next = 8;
                return updatePerson(_objectSpread2({
                  id: defaultValues.id
                }, form));

              case 8:
                if (typeof onDone === "function") {
                  onDone();
                }

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (typeof onError === "function") {
                  onError(_context.t0);
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  }, /*#__PURE__*/React.createElement(Form.Input, {
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Input, {
    name: "bornAt",
    label: "Date of Birth",
    type: "date",
    required: true
  }), /*#__PURE__*/React.createElement(Form.Select, {
    name: "sex",
    label: "Sex",
    options: [{
      label: "-",
      value: "",
      selected: true
    }, {
      label: "Female",
      value: "female"
    }, {
      label: "Male",
      value: "male"
    }],
    required: true
  }), /*#__PURE__*/React.createElement(Level, null, /*#__PURE__*/React.createElement(Level.Right, null, typeof onCancel === "function" && /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Button, {
    type: "cancel",
    onClick: onCancel
  }, "Cancel")), /*#__PURE__*/React.createElement(Level.Item, null, /*#__PURE__*/React.createElement(Form.SubmitButton, null, isCreate ? "Create Person" : "Update Person")))));
};
PersonForm.propTypes = {
  onDone: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  defaultValues: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    bornAt: PropTypes.string,
    sex: PropTypes.string
  })
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n      query People($first: Int!, $filters: PeopleFiltersInput) {\n        viewer {\n          people(first: $first, filters: $filters) {\n            edges {\n              node {\n                id\n                memberStatus\n                firstName\n                middleName\n                lastName\n                suffix\n                membershipNumber\n                bornAt\n                sex\n              }\n            }\n          }\n        }\n      }\n    "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var usePeopleSearch = function usePeopleSearch() {
  var _meta$data, _meta$data$viewer, _meta$data$viewer$peo, _meta$data$viewer$peo2;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    fetchPolicy: "cache-and-network"
  };

  var _useLazyQuery = useLazyQuery(gql(_templateObject$1()), options),
      _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
      query = _useLazyQuery2[0],
      meta = _useLazyQuery2[1];
  /**
   * Function that retrieves a list of people based on the given variables.
   *
   * @param {object} [form={}] - Search criteria
   * @param {object} [requestOptions={}] - Additional request options
   */


  var getPeople = function getPeople() {
    var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return query(_objectSpread2({
      variables: _objectSpread2({
        first: 100
      }, form)
    }, requestOptions));
  }; // Clean data for easier consumption


  var data = {
    people: (meta === null || meta === void 0 ? void 0 : (_meta$data = meta.data) === null || _meta$data === void 0 ? void 0 : (_meta$data$viewer = _meta$data.viewer) === null || _meta$data$viewer === void 0 ? void 0 : (_meta$data$viewer$peo = _meta$data$viewer.people) === null || _meta$data$viewer$peo === void 0 ? void 0 : (_meta$data$viewer$peo2 = _meta$data$viewer$peo.edges) === null || _meta$data$viewer$peo2 === void 0 ? void 0 : _meta$data$viewer$peo2.map(function (_ref) {
      var node = _ref.node;
      return node;
    })) || []
  };
  return [getPeople, _objectSpread2(_objectSpread2({}, meta), {}, {
    data: data
  })];
};

var Search = function Search() {
  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      search = _React$useState2[0],
      setSearch = _React$useState2[1];

  var _useDebounce = useDebounce(search, 300),
      _useDebounce2 = _slicedToArray(_useDebounce, 1),
      debouncedSearchTerm = _useDebounce2[0];

  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      people = _React$useState4[0],
      setPeople = _React$useState4[1];

  var _usePeopleSearch = usePeopleSearch({
    onCompleted: function onCompleted(response) {
      var _response$viewer, _response$viewer$peop, _response$viewer$peop2;

      setPeople(response === null || response === void 0 ? void 0 : (_response$viewer = response.viewer) === null || _response$viewer === void 0 ? void 0 : (_response$viewer$peop = _response$viewer.people) === null || _response$viewer$peop === void 0 ? void 0 : (_response$viewer$peop2 = _response$viewer$peop.edges) === null || _response$viewer$peop2 === void 0 ? void 0 : _response$viewer$peop2.map(function (edge) {
        return edge.node;
      }));
    }
  }),
      _usePeopleSearch2 = _slicedToArray(_usePeopleSearch, 2),
      getPeople = _usePeopleSearch2[0],
      loading = _usePeopleSearch2[1].loading;

  React.useEffect(function () {
    if (debouncedSearchTerm) {
      getPeople({
        filters: {
          search: debouncedSearchTerm
        }
      });
    }
  }, [debouncedSearchTerm]);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement("p", {
    className: "card-header-title"
  }, "People List")), /*#__PURE__*/React.createElement(Card.Content, null, /*#__PURE__*/React.createElement(Input, {
    value: search,
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    type: "search",
    autoComplete: "off",
    "aria-label": "Search by name",
    placeholder: "Search by name...",
    name: "search",
    loading: loading
  }), people.map(function (person) {
    return /*#__PURE__*/React.createElement(PersonCard, {
      person: person,
      key: person.id
    });
  })));
};

export { PersonForm, Search, useAddPerson, useUpdatePerson };
